<template>
    <div id="content">
        <el-row class="row" id="header_wrapper">
            <el-button @click="backToMyPage" id="back_button"><i class="el-icon el-icon-arrow-left"></i></el-button>
            <h1 id="use_rules_title">{{$t('rulesAtMyPage.title')}}</h1>
        </el-row>

        <el-row>
            <label id="personal_information_rules_title">{{$t('rulesAtMyPage.personalInformationRuleTitle')}}</label>
            <div id="personal_information_rules_wrapper">
                <div style="padding-left: 15px" v-html="personalInformationRules"></div>
            </div>
        </el-row>

        <el-row style="margin-top: 30px">
            <label id="use_system_rules_title">{{$t('rulesAtMyPage.useSystemRuleTitle')}}</label>
            <div id="system_use_rules_wrapper">
                <div style="padding-left: 15px" v-html="systemUseRules"></div>
            </div>
        </el-row>

        <el-row id="bottom_back_button_wrapper">
            <el-button id="bottom_back_button" @click="backToMyPage">{{$t('common.backButton')}}</el-button>
        </el-row>
    </div>
</template>

<script>
    import TextEditor from "../../components/TextEditor";
    import UserApi from "../../api/user/UserApi";
    import Pages from "../../router/Pages";

    export default {
        name: "RulesAtMyPage",

        components: {TextEditor},

        data() {
            return {
                personalInformationRules: "",
                systemUseRules: "",
                isOnlyRead: true
            }
        },

        created() {
            this.isOnlyRead = true
            UserApi.getPersonalInformationRulesByEndUser().then(result => {
                console.log(result)
                this.personalInformationRules = result.rules;
            })

            UserApi.getUseSystemRulesByEndUser().then(result => {
                console.log(result)
                this.systemUseRules = result.rules;
            })
        },

        methods: {
            backToMyPage() {
                this.$router.push(Pages.myPage.path)
            }
        }
    }
</script>

<style scoped lang="scss">

    #content {
        margin-left: 20%;
        margin-right: 20%;
    }

    #back_button:hover{
        background-color: white;
    }

    #bottom_back_button_wrapper{
        margin-top: 20px;
        text-align: center;
    }

    #bottom_back_button{
        width: 200px;
    }

    #back_button{
        font-size: 30px;
        border: none;
        width: 10%;
        text-align: left;
        float: left;
        padding-left: 0px;
    }

    #use_rules_title {
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        width: 79%;
        float: right;
        margin-right: 10%;
    }

    #header_wrapper{
        padding-bottom: 20px;
    }

    #system_use_rules_wrapper{
        width: 100%;
        display: inline-block;
        border: 1px solid #c2c2c2;
        max-height: 200px;
        overflow: scroll;
        margin-top: 10px
    }

    #personal_information_rules_wrapper{
        width: 100%;
        display: inline-block;
        border: 1px solid #c2c2c2!important;
        max-height: 200px;
        overflow: scroll;
        margin-top: 10px
    }

    @media only screen and (max-width: 450px){
        #content {
            margin-left: 0%;
            margin-right: 0%;
        }

        #back_button:hover{
            background-color: white;
        }

        #header_wrapper{
            position: relative;
        }

        #back_button{
            border: none;
            width: 15%;
            font-size: 140%;
            text-align: left;
            float: left!important;
        }

        #use_rules_title {
            text-align: center;
            font-size: 140%;
            font-weight: bold;
            width: 75%;
            float: right!important;
        }

        #personal_information_rules_title{
            font-size: 110%;
        }

        #use_system_rules_title{
            font-size: 110%;
        }

        #bottom_back_button{
            width: 100%
        }

        #system_use_rules_wrapper{
            width: 100%;
            display: inline-block;
            border: 1px solid #c2c2c2;
            max-height: 150px;
            overflow: scroll;
            margin-top: 10px
        }

        #personal_information_rules_wrapper{
            width: 100%;
            display: inline-block;
            border: 1px solid #c2c2c2!important;
            max-height: 150px;
            overflow: scroll;
            margin-top: 10px
        }
    }

</style>